import { combineReducers } from 'redux'
import {
    INVALIDATE_SUBREDDIT,
    REQUEST_POSTS,
    RECEIVE_POSTS
} from './actions'

function posts(
    state = {
        isFetching: false,
        didInvalidate: false,
    },
    action
) {
    let {subreddit,posts}=action;
    switch (action.type) {
        case INVALIDATE_SUBREDDIT:
            return Object.assign({}, state, {[subreddit.name]:{
                didInvalidate: true
            }});
        case REQUEST_POSTS:
            return Object.assign({}, state,{[subreddit.name]: {
                isFetching: true,
                didInvalidate: false
            }});
        case RECEIVE_POSTS:
            return Object.assign({}, state,{[subreddit.name]: {
                isFetching: false,
                didInvalidate: false,
                posts,
            }});
        default:
            return state
    }
}

const rootReducer = combineReducers({
    posts,
})

export default rootReducer